import { match } from 'path-to-regexp'

interface PageRouteResult {
  pageId?: string
  isTemplate: boolean
  isWebsite: boolean
}

interface MatchParams {
  id: string
  [key: string]: string | string[]
}

const getRootDomain = () => {
  const hostname = window.location.hostname
  const parts = hostname.split('.')

  return parts.slice(-2).join('.')
}

const getRootUrl = () => {
  return `${window.location.protocol}//${getRootDomain()}`
}

export default function usePageRouteDetector(): PageRouteResult {
  const pathname = window.location.pathname
  const host = window.location.host

  if (host.split('.')[0] === 'editor') {
    const rootDomain = getRootUrl()
    const newPath = `${rootDomain}${pathname}`
    window.location.replace(newPath)
  }

  const routes: { pattern: string; isTemplate: boolean; isWebsite: boolean }[] =
    [
      { pattern: '/page/:id/edit', isTemplate: false, isWebsite: false },
      {
        pattern: '/dashboard/page/:id/edit',
        isTemplate: false,
        isWebsite: false,
      },
      {
        pattern: '/page/template/:id/edit',
        isTemplate: true,
        isWebsite: false,
      },
      {
        pattern: '/dashboard/page/template/:id/edit',
        isTemplate: true,
        isWebsite: false,
      },
      {
        pattern: '/dashboard/websites/page/:id/edit',
        isTemplate: true,
        isWebsite: true,
      },
    ]

  for (const { pattern, isTemplate, isWebsite } of routes) {
    const matcher = match<MatchParams>(pattern, {})
    const result = matcher(pathname)

    if (result) {
      const { id } = result.params
      if (id && Number.isInteger(+id)) {
        return {
          pageId: id,
          isTemplate,
          isWebsite,
        }
      }
    }
  }

  return { isTemplate: false, isWebsite: false }
}
